export enum DealStatus {
  FAILED = 'failed',
  AUTHORIZED = 'authorized',
}
